import { useState } from 'react';

export default function SubscriptionCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = async () => {
    setLoading(true);
    setError('');

    try {
      // Create checkout session
      const res = await fetch('/api/subscriptions/create-intent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Failed to create checkout session');
      }

      const { clientSecret, amount } = await res.json();

      // Note: For production, integrate full Stripe Payment Element or Elements
      // For now, this prepares the intent. You'd complete payment in a separate modal/page.
      console.log('Payment intent created:', { clientSecret, amount });
      alert(`Payment intent created. Amount: $${amount.toFixed(2)}\n\nNote: Stripe payment form integration needed.`);

    } catch (err) {
      setError(err.message);
      console.error('Subscription error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      borderRadius: 12,
      border: '1px solid var(--border)',
      maxWidth: 500,
      margin: '0 auto'
    }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Premium Subscription</h2>
      <p style={{ color: 'var(--text-soft)', marginBottom: 16 }}>Unlock unlimited listings and more</p>

      <div style={{
        padding: '16px',
        background: 'var(--cream)',
        borderRadius: 8,
        marginBottom: 16
      }}>
        <div style={{ fontSize: 32, fontWeight: 700, color: 'var(--cherry)', marginBottom: 4 }}>
          $25<span style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-soft)' }}>/month</span>
        </div>
        <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: 'var(--text-primary)', lineHeight: 1.6 }}>
          <li>✅ Unlimited listings (all types)</li>
          <li>✅ All listing features</li>
          <li>✅ Priority support</li>
          <li>✅ Cancel anytime</li>
        </ul>
      </div>

      {error && (
        <div style={{
          padding: 12,
          background: 'rgba(244, 67, 54, 0.1)',
          border: '1px solid rgba(244, 67, 54, 0.3)',
          borderRadius: 6,
          color: '#d32f2f',
          fontSize: 13,
          marginBottom: 16
        }}>
          {error}
        </div>
      )}

      <button
        onClick={handleSubscribe}
        disabled={loading}
        style={{
          width: '100%',
          padding: '12px 16px',
          background: loading ? 'var(--text-soft)' : 'var(--cherry)',
          color: 'white',
          border: 'none',
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1,
          transition: 'all .2s'
        }}
      >
        {loading ? 'Processing...' : 'Subscribe Now'}
      </button>

      <p style={{
        fontSize: 12,
        color: 'var(--text-soft)',
        textAlign: 'center',
        marginTop: 12
      }}>
        By subscribing, you agree to our terms. Your subscription will renew automatically.
      </p>
    </div>
  );
}
